import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@citiguide/ui-components';
import { useChatStatus } from '../../hooks/useChatStatus';
import { useMenuStore } from '../../store/menuStore';
import ChatPanel from './ChatPanel';
import './chat.css';

/**
 * Entry point of the chat. Renders nothing at all unless GET /api/chat/status answered with a real
 * status body: with the tenant flag off (404, or the CDN's HTML 200) the map is exactly today's UI.
 */
export default function ChatRoot() {
  const { t } = useTranslation();
  const { data: status } = useChatStatus();
  const isOpen = useMenuStore((s) => s.isChatOpen);
  const setChatOpen = useMenuStore((s) => s.setChatOpen);
  const entryRef = useRef<HTMLDivElement>(null);
  const wasOpen = useRef(false);

  // Closing returns focus to the entry button.
  useEffect(() => {
    if (wasOpen.current && !isOpen) entryRef.current?.querySelector('button')?.focus();
    wasOpen.current = isOpen;
  }, [isOpen]);

  if (!status) return null;
  if (isOpen) return <ChatPanel status={status} />;
  return (
    <div className="chat-entry" ref={entryRef}>
      <Button size="lg" onClick={() => setChatOpen(true)}>
        {t('chat.entry')}
      </Button>
    </div>
  );
}
